// extracted by mini-css-extract-plugin
export default {"color":"Founders_color__1CV4P","middleTric":"Founders_middleTric__TjaF4","iconsColor":"Founders_iconsColor__+E+hR","bgCard":"Founders_bgCard__14HeY"};